import { IMediaItem } from 'modules/media/interfaces/api';
import { useCallback } from 'react';
import mediaApis from '../apis';
import { getMessageError } from 'services/response';
import useGetManageLibrary from './useGetManageLibrary';
import toast from 'utils/toast';

type UseDeleteMediaItemProps = {
  currentPath: string;
};

export const useDeleteMediaItem = ({ currentPath }: UseDeleteMediaItemProps) => {
  const [, mutate] = useGetManageLibrary(true);

  const deleteItem = useCallback(
    async (item: IMediaItem) => {
      try {
        const res = await mediaApis.deleteMediaItem(item.id);

        if (res?.data) {
          toast.success('Deleted successfully.');
          mutate(currentPath);
        }
      } catch (error) {
        toast.error(getMessageError(error) || 'An error occurred while deleting the item.');
      }
    },
    [mutate, currentPath]
  );

  return { deleteItem };
};
